import api from './api';

const AuthService = {
  // Login dengan username/email dan password
  login: async (credentials) => {
    try {
      const response = await api.post('/auth/login', credentials);
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Google OAuth functionality has been removed

  // Logout
  logout: async () => {
    try {
      // Panggil endpoint logout untuk menghapus cookie di server
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Error during logout:', error);
    } finally {
      // Hapus data lokal
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },

  // Mendapatkan user yang sedang login
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    if (!user) return null;
    
    const parsedUser = JSON.parse(user);
    
    // Ensure user has an id property
    if (!parsedUser.id && parsedUser.userId) {
      parsedUser.id = parsedUser.userId;
    }
    
    return parsedUser;
  },

  // Cek apakah user sudah login
  isAuthenticated: () => {
    // Cek token di localStorage - synchronous check
    const localToken = localStorage.getItem('token');
    const localUser = localStorage.getItem('user');
    
    // Return true if we have both token and user data
    return !!(localToken && localUser);
  },
  
  // Async validation that can be called when needed
  validateAuthentication: async () => {
    // Cek token di localStorage
    const localToken = localStorage.getItem('token');
    
    if (!localToken) {
      return false;
    }
    
    try {
      // Cek status autentikasi dari server
      const response = await api.get('/auth/me');
      if (response.data && response.data.user) {
        // Jika session valid, simpan user data di localStorage
        localStorage.setItem('user', JSON.stringify(response.data.user));
        return true;
      }
      return false;
    } catch (error) {
      console.warn('Auth validation error:', error);
      // Only return false for auth errors (401)
      if (error.response && error.response.status === 401) {
        return false;
      }
      // For network errors or other issues, assume token is still valid
      // This prevents logout when backend is temporarily unavailable
      return true;
    }
  },

  // Mendapatkan informasi user dari token
  getUserInfo: async () => {
    try {
      const response = await api.get('/auth/me');
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Lupa Password
  forgotPassword: async (email) => {
    try {
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },

  // Reset Password
  resetPassword: async (token, newPassword) => {
    try {
      const response = await api.post('/auth/reset-password', { token, newPassword });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : { message: 'Network error' };
    }
  },
};

export default AuthService;